import React from 'react';
import PropTypes from 'prop-types';
import {Button, Message} from 'epic-diesel-common';
import {buttonTypes, priority} from 'epic-diesel-common/src/constants';
import Input from 'epic-diesel-form/src/components/form/Input';
import styles from './VerifyEmailSection.pcss';
import CheckBox from 'epic-diesel-form/src/components/form/CheckBox';

export default class VerifyEmailSection extends React.Component {
    static propTypes = {
        messages: PropTypes.object,
        getMessage: PropTypes.func,
        emailVerified: PropTypes.bool,
        email: PropTypes.string,
        verificationSent: PropTypes.bool,
        resendEmailVerification: PropTypes.func
    };

    static defaultProps = {
        emailVerified: false,
        email: 'Unknown',
        verificationSent: false
    };

    resendEmailVerification = () => {
        const {emailVerified} = this.props;
        if (!emailVerified) {
            this.props.resendEmailVerification();
        }
    };

    render() {
        const {messages, getMessage, email, verificationSent, emailVerified} = this.props;

        const subtitleText = getMessage(messages, 'epic.affiliate.presignup.email.subtitle.v2');

        return (
            <>
                <h2>
                    <Message code="epic.affiliate.presignup.email.header.v2" />
                    {' *'}
                </h2>
                <p>
                    <Message code="epic.affiliate.presignup.email.title.v2" />{' '}
                    <small
                        className={styles.anchor}
                        dangerouslySetInnerHTML={{__html: subtitleText}}
                    />
                </p>
                {emailVerified ? (
                    <CheckBox
                        name="enabled2MFA"
                        validations="checked"
                        validationError={getMessage(
                            messages,
                            'errors.com.epicgames.validation.required_field.v2'
                        )}
                        value={emailVerified}>
                        <Message
                            code={`epic.affiliate.presignup.email.${
                                emailVerified ? 'enabled' : 'disabled'
                            }.v2`}
                        />
                    </CheckBox>
                ) : (
                    <div className={styles.emailWrapper}>
                        <div className={styles.email}>
                            <Input type="email" name="email" value={email} disabled={true} />
                        </div>
                        <Button
                            onClick={this.resendEmailVerification}
                            priority={priority.PRIMARY}
                            type={buttonTypes.SUBMIT}
                            disabled={verificationSent}
                            theme="dark">
                            <Message
                                code={`epic.affiliate.common.${
                                    verificationSent ? 'sent' : 'resend'
                                }`}
                            />
                        </Button>
                    </div>
                )}
            </>
        );
    }
}
